import React, { useEffect, useState } from 'react';
import './Footer.css';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faEnvelope, 
  faPhoneAlt, 
  faMapMarkerAlt 
} from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
    const [productos, setProductos] = useState([]);
    const [contactos, setContactos] = useState([]);

    useEffect(() => {
        cargarProductos();
        cargarContacto();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos?.slice(0, 3) || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto?.reverse()[0] || {});
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    return (
        <div className='FooterContain'>
            {/* Columna 1: Solo Logo */}
            <div className='footerText logoColumn'>
                <Anchor to='' target="_blank">
                    <img src={logo} alt="logo" />
                </Anchor>
            </div>

            {/* Columna 2: Nombre + Redes Sociales */}
            <div className='footerText brandColumn'>
                <h2>{contactos.nombre || 'Inversiones Anahi'}</h2>
                <div className='socials'>
                    <Anchor to={contactos.instagram || '#'} target="_blank">
                        <i className='fa fa-instagram'></i>
                    </Anchor>
                    <Anchor to={`tel:${contactos.telefono || ''}`} target="_blank">
                        <i className='fa fa-whatsapp'></i>
                    </Anchor>
                    <Anchor to={contactos.facebook || '#'} target="_blank">
                        <i className='fa fa-facebook'></i>
                    </Anchor>
                </div>
            </div>

            {/* Columna 3: Contacto CON ICONOS */}
            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email || ''}`} target="_blank">
                    <FontAwesomeIcon icon={faEnvelope} />
                    {contactos.email || 'admin@gmail.com'}
                </Anchor>
                <Anchor to={`tel:${contactos.telefono || ''}`} target="_blank">
                    <FontAwesomeIcon icon={faPhoneAlt} />
                    {contactos.telefono || '966626906'}
                </Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion || 'Ica')}`} target="_blank">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    {contactos.direccion || 'Ica'}
                </Anchor>
            </div>

            {/* Columna 4: Productos */}
            <div className='footerText'>
                <h3>Productos</h3>
                {productos?.map((item, index) => (
                    <Anchor key={item.id || `product-${index}`} to=''>
                        {item?.titulo?.slice(0, 33)}
                    </Anchor>
                ))}
            </div>

            {/* Columna 5: Dashboard */}
            <div className='footerText'>
                <h3>Acceso</h3>
                <Anchor to='/dashboard' className='btnAnch'>
                    <FontAwesomeIcon icon={faUser} /> Dashboard
                </Anchor>
            </div>
        </div>
    );
}